import { create } from "zustand";
import api from "../lib/api";

export const useSettingsStore = create((set) => ({
    settings: {
        company_name: "Otel Pro",
        tagline: "Türkiye'nin Otel Endüstrisi Platformu",
        logo_url: "https://customer-assets.emergentagent.com/job_otel-central/artifacts/tvucn0yf_wordmark-light.svg",
        phone: "0532 737 13 06",
        email: "info@otel-pro.com",
        whatsapp: "905327371306",
        social_media: {},
        seo_defaults: { meta_title: "Otel Pro", meta_desc: "" },
        analytics_id: "",
        maintenance_mode: false,
    },
    loaded: false,
    fetchSettings: async () => {
        try {
            const { data } = await api.get("/site-settings/public");
            set({ settings: data, loaded: true });
        } catch (e) {
            set({ loaded: true });
        }
    },
}));
